import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const MotherContext = createContext({ mother: null, token: '', loading: true });
const TOKEN_KEY = 'mother_token';

export function MotherProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || '');
  const [mother, setMother] = useState(null);
  const [loading, setLoading] = useState(!!token);

  const refresh = useCallback(async (newToken) => {
    const t = newToken ?? token;
    if (!t) {
      setMother(null);
      setLoading(false);
      return null;
    }
    try {
      const res = await api.get('/mothers/me', { headers: { 'X-Mother-Token': t } });
      setMother(res.data.mother);
      return res.data.mother;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken('');
      setMother(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  const login = (newToken, m) => {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
    setMother(m);
    setLoading(false);
  };

  const logout = async () => {
    try { await api.post('/mothers/logout', null, { headers: { 'X-Mother-Token': token } }); } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setToken('');
    setMother(null);
  };

  return (
    <MotherContext.Provider value={{ mother, token, loading, login, logout, refresh }}>
      {children}
    </MotherContext.Provider>
  );
}

export function useMother() {
  return useContext(MotherContext);
}
